var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.63331C10.0001 4.71642 9.98886 4.79873 9.96688 4.87551C9.94491 4.95229 9.91265 5.02201 9.87196 5.08067L7.6343 8.32018C7.33347 8.75546 6.92546 9 6.50002 9C6.07458 9 5.66657 8.75546 5.36573 8.32018L3.12808 5.08067C3.08746 5.02186 3.05524 4.95206 3.03327 4.87524C3.01129 4.79842 2.99999 4.71609 3 4.63295C3.00001 4.54981 3.01134 4.46749 3.03335 4.39069C3.05535 4.31388 3.08759 4.2441 3.12822 4.18533C3.16886 4.12655 3.2171 4.07993 3.27019 4.04814C3.32328 4.01634 3.38018 3.99998 3.43764 4C3.4951 4.00002 3.55199 4.01641 3.60507 4.04825C3.65815 4.08008 3.70637 4.12673 3.74699 4.18554L5.98435 7.42505C6.05207 7.52305 6.13246 7.6008 6.22094 7.65384C6.30941 7.70688 6.40425 7.73418 6.50002 7.73418C6.59579 7.73418 6.69062 7.70688 6.7791 7.65384C6.86758 7.6008 6.94797 7.52305 7.01568 7.42505L9.25304 4.18722C9.31416 4.09873 9.39203 4.03843 9.47681 4.01393C9.56159 3.98942 9.64949 4.00182 9.72941 4.04955C9.80933 4.09727 9.87769 4.1782 9.92585 4.28209C9.974 4.38599 9.99981 4.50821 10 4.63331Z",
    fill: "#B0AFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/ChevronDown.b260e282794c8e1795791c8e261b6828.svg";
export { ForwardRef as ReactComponent };